const ROLES_IT = {
  admin: "Amministratore",
  companion: "Compagno",
  comptable: "Contabile",
  gestionnaire: "Gestore",
  manager: "Manager",
  membre: "Membro",
  operative: "Operativo",
} as const;

export default ROLES_IT;
